import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=0a0a5a0c&scoped=true&"
import script from "./base-select.vue?vue&type=script&lang=js&"
export * from "./base-select.vue?vue&type=script&lang=js&"
import style0 from "./base-select.vue?vue&type=style&index=0&id=0a0a5a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a5a0c",
  null
  
)

export default component.exports